import { Component } from '@angular/core';
import { Angulartics2Mixpanel } from 'angulartics2/mixpanel';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  constructor(private readonly mixpanel: Angulartics2Mixpanel) {
    this.mixpanel.startTracking();
  }
}
